import type { NavItem } from './createModuleNav';

export function pruneNavForSidebar(nav: NavItem): NavItem | null {
  if (nav.children.length > 0) {
    const prunedChildren = nav.children
      .map(pruneNavForSidebar)
      .filter((child): child is NavItem => child !== null);

    if (prunedChildren.length === 0) {
      return null;
    }

    return { ...nav, children: prunedChildren };
  }

  if (!nav.route.label) {
    return null;
  }

  return nav;
}

export function filterNavByPermissions(
  nav: NavItem,
  permissions: Map<string, boolean>,
): NavItem | null {
  if (nav.children.length > 0) {
    const filteredChildren = nav.children
      .map((child) => filterNavByPermissions(child, permissions))
      .filter((child): child is NavItem => child !== null);

    if (filteredChildren.length === 0) {
      return null;
    }

    return { ...nav, children: filteredChildren };
  }

  const { requiredPermission } = nav.route;

  if (!requiredPermission) {
    return nav;
  }

  return permissions.get(requiredPermission) ? nav : null;
}
